import { createGlobalStyle } from 'antd-style'

export const Global = createGlobalStyle`
  .ant-segmented-item-label {
    display: flex;
    align-items: center;

    .ant-segmented-item-icon {
      display: inline-flex;
      align-items: center;
    }
  }

  .ant-space-compact-block {
    justify-content: center;
  }

  .ant-typography {
    margin-bottom: 0 !important;
  }

  .ant-btn-icon {
    display: flex;
  }

  .ant-input-number {
    width: 100%
  }

  .w-full {
    width: 100% !important;
  }

  .h-full {
    height: 100%;
  }

  .pointer {
    cursor: pointer;
  }

  .text-center {
    text-align: center;
  }

  .m-0 {
    margin: 0px !important;
  }

  .mb-0 {
    margin-bottom: 0px !important;
  }

  .mb-10 {
    margin-bottom: 10px !important;
  }

  .mb-16 {
    margin-bottom: 16px !important;
  }

  .mb-20 {
    margin-bottom: 20px !important;
  }

  .mb-30 {
    margin-bottom: 30px !important;
  }

  .mt-20{
    margin-top: 20px !important;
  }

  .h-auto {
    height: auto;
  }

  .overflowX-auto{
    overflow-x: auto
  }

  .ant-modal .ant-modal-header {
    margin-bottom: 24px
  }

  .ant-modal .ant-modal-footer {
    display:flex;
    align-items: center;
    justify-content: center
  }

  .card-body-no-padding {
    .ant-card-body {
      padding:0
    }
  }

  .steps-full-width {
    .ant-steps-item-title {
      width:100%
    }
  }

  .range-picker-width {
    min-width: 320px
  }

  .avatar-max-width {
    max-width: 200px
  }

  .text-wrap-nowrap {
   white-space: nowrap;
  }

  //Form-builder

  .ql-picker.ql-size .ql-picker-label::before,
.ql-picker.ql-size .ql-picker-item::before {
  content: attr(data-value) !important; /* Show actual value */
  text-transform: none; /* Prevent Quill from overriding */
}

.ql-picker.ql-size .ql-picker-item[data-value="12px"]::before {
  content: "12px" !important;
}
.ql-picker.ql-size .ql-picker-item[data-value="14px"]::before {
  content: "14px" !important;
}
.ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {
  content: "16px" !important;
}
.ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
  content: "18px" !important;
}
.ql-picker.ql-size .ql-picker-item[data-value="20px"]::before {
  content: "20px" !important;
}
.ql-picker.ql-size .ql-picker-item[data-value="24px"]::before {
  content: "24px" !important;
}
.ql-picker.ql-size .ql-picker-item[data-value="28px"]::before {
  content: "28px" !important;
}
.ql-picker.ql-size .ql-picker-item[data-value="32px"]::before {
  content: "32px" !important;
}


.fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background: white;
  border: none;
  padding: 10px;
}

.fullscreen .ql-container {
  height: calc(100vh - 50px) !important;
}

.fullscreen .ql-toolbar {
  background: #f3f3f3;
  position: sticky;
  top: 0;
  z-index: 10;
}

.ql-fullscreen {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 36px;
  height: 24px;
  background: transparent;
  border: none;
}

.ql-fullscreen::before {
  content: "⛶"; /* Fullscreen icon */
  font-size: 16px;
  color: #000;
  line-height: 1;
}

.fullscreen .ql-fullscreen::before {
  content: "✖"; /* Exit fullscreen icon */
  font-size: 16px;
  line-height: 1;
}

.ql-html-popupTitle {
  margin: 10px;
  font-weight: 600;
}


.ql-html-buttonGroup {
  bottom: -30px !important;
  transform: scale(1.3) !important;
  border-radius: 12px !important;
}

.ql-html-buttonCancel {
  margin-right: 10px;
}

.ql-html-buttonOk {
  background-color: #1677ff;
  color: white;
}

.ql-html-buttonCancel, .ql-html-buttonOk {
  border-radius: 4px;
  padding: 3px;
  border: none;
  cursor: pointer;
  min-width: 60px;
}

div.ql-html-textArea.ql-container {
  border-radius: 12px !important;
}

.ql-mark {
  font-size: 16px;
  line-height: 1;
    filter: grayscale(1);
}

mark, .mark-blot {
background-color: #faf594;
  border-radius: 6.4px;
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;
  padding: 1.6px 4.8px;
}

.table-column-max-width {
  max-width: 250px !important;
}

.select-min-width {
  min-width: 150px;
}


.no-style-list {
  padding: 0 0 0 10px;
  
}

.export-button {
  .ant-popover-inner {
    padding: 0;
  }
}
`
